<template>
    <div>
        <div class="package-progress">
            <div class="bar" :class="barClass" :style="{width: percent + '%'}"></div>
        </div>
        <div class="progress-meta">{{ pkgAllocatedHours }} of {{ pkgTargetHours }} hours allocated</div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "PackageProgress",
        computed: {
            ...mapGetters(['pkgTargetHours', 'pkgAllocatedHours', 'pkgRemainingHours']),
            percent() {
                if (!this.pkgTargetHours) return 0;
                return Math.min(100, (this.pkgAllocatedHours / this.pkgTargetHours) * 100);
            },
            barClass() {
                if (this.pkgRemainingHours < 0) return 'is-over';
                if (this.pkgRemainingHours === 0 && this.pkgTargetHours) return 'is-full';
                return '';
            }
        }
    };
</script>

<style lang="scss" scoped>
    .package-progress {
        height: 8px;
        background: #e6ebf1;
        border-radius: 999px;
        overflow: hidden;

        .bar {
            height: 100%;
            border-radius: 999px;
            background: #366ea5;
            transition: width 150ms;

            &.is-full {
                background: #2e7d4f;
            }

            &.is-over {
                background: #c0392b;
            }
        }
    }

    .progress-meta {
        font-size: 0.75rem;
        color: #7a8a9d;
        margin-top: 0.4rem;
    }
</style>
